import client from './client';

// Phiên bản app mới nhất (công khai) — để app native tự kiểm tra cập nhật.
export const getAppVersion = () => client.get('/app/version').then((r) => r.data);
